<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ partner.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PartnersTabLinks />
                    <DiscountCardsTable
                        class="mt-4"
                        :list="discount_cards"
                        @select="(id) => $router.push(`/partners/${partner.id}/discount-cards/${id}`)"
                    />
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create"
                    >Создать</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PartnersTabLinks from '@/components/partner/PartnersTabLinks';
    import DiscountCardsTable from '@/components/discount-cards/DiscountCardsTable';

    export default {
        name: 'PartnerDiscountCards',

        components: {
            PartnersTabLinks,
            DiscountCardsTable,
        },

        data() {
            return {
                partner: {},
                discount_cards: [],
            };
        },

        computed: {},

        mounted() {
            const id = parseInt(this.$route.params.id);
            Vue.axios
                .get('/partners/' + id)
                .then(resp => {
                    const partner = resp.data;
                    if (!partner.discount_cards) partner.discount_cards = [];
                    this.partner = partner;
                    Vue.axios
                        .get('/discount-cards/partner/' + id)
                        .then(resp => {
                            this.discount_cards = resp.data;
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка загрузки данных.');
                        });
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            create() {
                this.$router.push(
                    '/partners/' + this.partner.id + '/discount-cards/create'
                );
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
        },
    };
</script>
